module.exports = __webpack_public_path__ + "img/5.db00c5ff.jpg";